import React from 'react';
import { MapPin, PenTool, Award, Shield, ThumbsUp } from 'lucide-react';
export function WhyChoose() {
  const reasons = [{
    title: 'Local Michigan Glass Experts',
    copy: 'Family-owned since 2000 and serving homeowners throughout Howell, Ann Arbor, Novi and Southeast Michigan.',
    icon: MapPin
  }, {
    title: 'Custom Design & Measurement',
    copy: "Kosin's Glass reviews your bathroom, takes proper measurements and helps design the right shower glass solution.",
    icon: PenTool
  }, {
    title: 'Professional Installation',
    copy: 'Experienced glass technicians install custom shower doors and enclosures with attention to fit, safety and finish.',
    icon: Award
  }, {
    title: 'Quality Glass & Hardware',
    copy: 'Choose from quality glass, trusted shower lines, 18 glass designs and textures, and many hardware finishes.',
    icon: Shield
  }, {
    title: 'No High-Pressure Sales',
    copy: 'Get clear recommendations, options and a free in-home quote before making a decision.',
    icon: ThumbsUp
  }, {
    title: 'Lifetime Installation Guarantee',
    copy: "Kosin's shower door installations are backed by a lifetime guarantee.",
    icon: Shield
  }];
  return <section className="py-20 bg-white" data-id="element-1527" data-mp="2fhlbmj22pfe1">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1528" data-mp="2fginuk01rt2c">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1529" data-mp="2ahz2akpd8jai">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1530" data-mp="2afw1r6ql77rj">
            Why Choose Kosin's Glass for Shower Doors?
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1531" data-mp="21i2esmeppqh1">
          {reasons.map((reason, i) => <div key={i} className="bg-gray-50 p-8 rounded-lg border border-gray-100 flex gap-4 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1532" data-mp="1wkahfcvatc5g" data-mpi={i}>
              <div className="shrink-0 mt-1" data-id="element-1533" data-mp="1p6rogty3fcvm">
                <reason.icon className="w-6 h-6 text-primary" data-id="element-1534" data-mp="1p603ed24gxjl" />
              </div>
              <div data-id="element-1535" data-mp="1tyt6kwhxzxtk">
                <h3 className="text-lg font-bold text-navy mb-2" data-id="element-1536" data-mp="1tzcfjnpm7bvg">
                  {reason.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1537" data-mp="1f7ajyfukv518">
                  {reason.copy}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}